import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=876ddc80&scoped=true&"
import script from "./Environments.vue?vue&type=script&lang=js&"
export * from "./Environments.vue?vue&type=script&lang=js&"
import style0 from "./Environments.vue?vue&type=style&index=0&id=876ddc80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ddc80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VSheet})
